import { get } from 'app/utils/axios/kheti'
import Categories from '../models/crop'

//crop_ids and brand_ids can be comma seperated list or single cropId/brandId also
export interface RequestParmas {
  crop_ids: string
  brand_ids: string
  lang: string
  dc_id: number
}

const fetchAllCategoriesV2 = async (params: Partial<RequestParmas>) => {
  try {
    return await get<Categories[]>(`/hyperlocal/v1/all-categories`, params)
  } catch {
    return null
  }
}

export default fetchAllCategoriesV2
